import { render, staticRenderFns } from "./medicalLog.vue?vue&type=template&id=8e907532&scoped=true"
import script from "./medicalLog.vue?vue&type=script&lang=js"
export * from "./medicalLog.vue?vue&type=script&lang=js"
import style0 from "./medicalLog.vue?vue&type=style&index=0&id=8e907532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e907532",
  null
  
)

export default component.exports